import { UtilityServices } from './../../../Services/utility.services';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirmation-fail',
  templateUrl: './confirmation-fail.component.html'
})
export class ConfirmationFailComponent implements OnInit {

  constructor(
    private readonly utilityService: UtilityServices,
  ) { }

  moveNext() {
    this.utilityService.navigateToNext('/login');

  }

  ngOnInit(): void {
    // This is intentional
  }


}
